import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/benchling_apps_analytics_events.py
export const BENCHLING_APPS_ANALYTICS_ACTIONS = {
  // WRITE_ACTIONS
  BENCHLING_APP_CREATED: {
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_app_created',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  BENCHLING_APP_NAME_UPDATED: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_app_name_updated',
  },
  BENCHLING_APP_DESCRIPTION_UPDATED: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'updated_benchling_app_description',
  },

  BENCHLING_APP_DEPENDENCIES_UPDATED: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_app_dependencies_updated',
  },
  BENCHLING_APP_ARCHIVED: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_app_archived',
  },
  BENCHLING_APP_UNARCHIVED: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_app_unarchived',
  },
  BENCHLING_APP_API_KEY_REGENERATED: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_app_api_key_regenerated',
  },
  BENCHLING_APP_API_KEY_DELETED: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_app_api_key_deleted',
  },
  BENCHLING_APP_SECRET_REGENERATED: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_app_secret_regenerated',
  },
  BENCHLING_APP_SECRET_DELETED: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_app_secret_deleted',
  },
  CREATED_APP_CANVAS: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'created_app_canvas',
  },
  ARCHIVED_APP_CANVAS: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'archived_app_canvas',
  },
  UNARCHIVED_APP_CANVAS: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'unarchived_app_canvas',
  },
  SUBMITTED_APP_CANVAS: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'submitted_app_canvas',
  },
  SENT_PLAYGROUND_WEBHOOK: {
    actionCategory: ACTION_CATEGORY.WRITE,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'sent_playground_webhook',
  },
  // READ ACTIONS
  BENCHLING_APP_LISTING_PAGE_OPENED: {
    actionCategory: ACTION_CATEGORY.READ,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_apps_listing_page_opened',
  },
  BENCHLING_APP_DETAILS_PAGE_OPENED: {
    actionCategory: ACTION_CATEGORY.READ,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_app_details_page_opened',
  },
  CREATE_BENCHLING_APP_PAGE_OPENED: {
    actionCategory: ACTION_CATEGORY.READ,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_app_create_page_opened',
  },
  BENCHLING_APP_WEBHOOK_PLAYGROUND_PAGE_OPENED: {
    actionCategory: ACTION_CATEGORY.READ,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'benchling_app_webhook_playground_page_opened',
  },
  WEBHOOKS_REFERENCE_PAGE_OPENED: {
    actionCategory: ACTION_CATEGORY.READ,
    module: ANALYTICS_MODULE.BENCHLING_APPS,
    action: 'webhooks_reference_page_opened',
  },
};
